export const CUSTOMER_COMMUNICATION_ROUTE = 'customer-communication';
export const TRANSPORT_ROUTE = 'transport';
export const PLANNING_ROUTE = 'planning';